module.exports = __webpack_public_path__ + "img/andy.efb07435.png";